module.exports = __webpack_public_path__ + "static/img/B (10).21324607.png";